<template>
  <div class="d-flex min-height align-items-center">
    <vue-headful
      :html="{
        body: { class: 'bg-image' }
      }"
    />
    <div class="container-fluid px-4 mx-2">
      <div class="text-center">
        <p
          class="dashboard-empty text-white text-center mt-4"
          v-html="text"
        ></p>
        <router-link :to="link" class="btn btn-warning btn-block">
          {{ button }}
        </router-link>
        <router-link
          v-if="tutorial"
          :to="{ name: 'tutorial', params: { back: tutorial } }"
          class="btn btn-light btn-block"
          >Bekijk nog eens hoe het werkt</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    link: Object,
    button: String,
    tutorial: String
  }
};
</script>

<style scoped></style>
